
import { index } from '@/api/categories'
import { index as getStudios } from '@/api/studios'
import { store, update } from '@/api/original_dramas'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})

export default class extends Vue {
  @Prop() public model!: Record<string, any>

  studios = []
  categories = []

  rules = {
    thumbnail: [
      { required: true, message: '请上传剧本封面', trigger: 'blur' }
    ],
    // eslint-disable-next-line
    title_zh: [
      { required: true, message: '请输入品牌中文名称', trigger: 'blur' }
    ],
    // eslint-disable-next-line
    title_en: [
      { required: false, message: '请输入品牌英文名称', trigger: 'blur' }
    ],
    introduce: [
      { required: false, message: '请输入品牌简介', trigger: 'blur' }
    ],
    country: [
      { required: false, message: '请输入品牌所属国家', trigger: 'blur' }
    ]
  }

  loading = false

  // validate form
  validateForm (): void {
    const el: any = this.$refs.form
    el.validate((val: boolean) => val && this.sendRequest())
  }

  // send login request
  async sendRequest () {
    this.loading = true
    const params: Record<string, any> = this.model
    try {
      if (params.id) {
        await update(params.id, params)
      } else {
        await store(params)
      }
      this.$eva.success('Submit the success!')
      // this.$router.push({ name: 'original_dramas' })
    } finally {
      this.loading = false
    }
  }

  async created () {
    const { data } = await index({ include: 'parent' })
    this.categories = data
    const response = await getStudios()
    this.studios = response.data
  }
}
